import { ErrorComponent } from '@openx/components-core/lib/Error/Error.tsx';
import { NotFoundImage } from '@openx/components-core/lib/Error/pictures/NotFound.tsx';
import { useCallback, useEffect } from 'react';
import { getEnvironmentConfigs } from '../../../environmentConfigs.ts';
import { useAuth } from '../components/AuthContext.tsx';

const REDIRECT_TO_SEARCH_PARAM = 'redirect_to';

const redirectToUnityLoginPage = () => {
  const { unityOrigin } = getEnvironmentConfigs();
  const currentUrl = new URL(window.location.href);

  if (unityOrigin) {
    const url = new URL(currentUrl.searchParams.get(REDIRECT_TO_SEARCH_PARAM) ?? unityOrigin);
    url.pathname = '/login';

    window.location.href = url.toString();
  }
};

export const Logout = ({ autoRedirectTimeout = 5_000 }) => {
  const { signOut } = useAuth();

  const signOutAndRedirect = useCallback(async () => {
    try {
      await signOut();
    } finally {
      redirectToUnityLoginPage();
    }
  }, [signOut]);

  useEffect(() => {
    const timer = setTimeout(signOutAndRedirect, autoRedirectTimeout);

    return () => clearTimeout(timer);
  }, [autoRedirectTimeout, signOutAndRedirect]);

  return (
    <ErrorComponent
      title="See You Soon!"
      subtitle="Your session has ended. We're taking you back to the login screen."
      actions={[
        {
          children: 'Log In Again',
          color: 'secondary',
          'data-test': 'log-in-again',
          onClick: signOutAndRedirect,
          variant: 'contained',
        },
      ]}
      PictureComponent={NotFoundImage}
      data-test="logout-page"
    />
  );
};
